import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { ArrowLeft, Clock } from "lucide-react";
import Logo from "@/components/Logo";

export default function Proximamente() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex flex-col" style={{ background: "var(--af-black)" }}>
      <div className="af-container flex items-center gap-3" style={{ height: 68, borderBottom: "1px solid var(--af-border-dark)" }}>
        <button data-testid="prox-back" onClick={() => navigate("/")} className="text-white/80 hover:text-af-orange-core"><ArrowLeft size={22} /></button>
        <Link to="/"><Logo height={40} /></Link>
      </div>
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="af-card p-10 max-w-lg text-center" data-testid="proximamente">
          <div className="mx-auto rounded-full flex items-center justify-center mb-5" style={{ width: 64, height: 64, background: "rgba(232,93,4,0.15)", border: "1px solid rgba(232,93,4,0.4)" }}>
            <Clock className="text-af-orange-core" size={30} />
          </div>
          <h1 className="h-impact text-white text-2xl md:text-3xl">Ya tengo un trámite</h1>
          <p className="text-white/70 mt-4 leading-relaxed">
            Muy pronto podrás dar seguimiento a tu trámite desde aquí. Esta sección estará disponible en la siguiente fase de la plataforma.
          </p>
          <button data-testid="prox-iniciar" onClick={() => navigate("/registro")} className="af-btn-primary mt-8">Iniciar precalificación gratuita</button>
        </div>
      </div>
    </div>
  );
}
